import {Controller, useController} from "react-hook-form";

import {RadioGroup} from "@pg-design/radio-module";
import {IRadioGroupProps} from "@pg-design/radio-module/src/types/IRadioGroupProps";

type IProps = Omit<IRadioGroupProps, "onChange">;

export function RadioGroupControlled(props: IProps) {
    const {name, ...radioGroupProps} = props;
    const fieldController = useController({name});

    if (!fieldController) {
        throw new Error("RadioGroupControlled is not wrapped in FormProvider, in this case, please wrap it with FormProvider");
    }

    return (
        <Controller
            name={name}
            render={({field}) => <RadioGroup onChange={(value) => field.onChange(value)} value={field.value} name={name} {...radioGroupProps} />}
        />
    );
}
import {Controller, useController} from "react-hook-form";

import {RadioGroup} from "@pg-design/radio-module";
import {IRadioGroupProps} from "@pg-design/radio-module/src/types/IRadioGroupProps";

type IProps = Omit<IRadioGroupProps, "onChange">;

export function RadioGroupControlled(props: IProps) {
    const {name, ...radioGroupProps} = props;
    const fieldController = useController({name});

    if (!fieldController) {
        throw new Error("RadioGroupControlled is not wrapped in FormProvider, in this case, please wrap it with FormProvider");
    }

    return (
        <Controller
            name={name}
            render={({field}) => <RadioGroup onChange={(value) => field.onChange(value)} value={field.value} name={name} {...radioGroupProps} />}
        />
    );
}
